import React from 'react';
import styled from 'styled-components';

import { getImageURL } from 'utils/cloudinary';

import type { Product } from '../types';
import { StyleOptions } from './consts';

const Container = styled.div`
  align-items: center;
  display: flex;
  height: ${({ size }: { size: string }): string =>
    StyleOptions[size].imageHeight};
  justify-content: center;
`;

const Picture = styled.img`
  border-radius: ${({ size }: { size: string }): string =>
    StyleOptions[size].imageBorderRadius};
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  height: ${({ size }: { size: string }): string =>
    StyleOptions[size].imageHeight};
  object-fit: cover;
  width: 100%;
`;

const Image = ({ product, size }: { product: Product; size: string }) => {
  const {
    product_instruction_image: productInstructionImage,
    product_image_url: productImageURL,
    product_name: productName,
    product_title: productTitle,
  } = product;

  const image = productInstructionImage[0] ?? productImageURL;

  return (
    <Container size={size}>
      <Picture
        alt={productName ?? productTitle}
        size={size}
        src={getImageURL(image, { height: 190 })}
      />
    </Container>
  );
};

export default Image;
